<template>
	<v-container>
		<v-row>
			<v-col cols="12" sm="6">
				<a-hotel-select
					v-model="hotelCode"
					:hotels="hotels"
					@change="getParameters"
				></a-hotel-select>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<v-switch
					v-model="parameters.operating"
					label="Действующий"
					:disabled="!allowEditBase"
					@change="gotChanges = true"
				></v-switch>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<v-subheader>Общие параметры</v-subheader>
				<v-text-field
					v-model="parameters.code"
					label="Код"
					:disabled="!allowEditBase"
					@change="gotChanges = true"
				></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<v-text-field
					v-model="parameters.name"
					label="Название"
					:disabled="!allowEditBase"
					@change="gotChanges = true"
				></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<v-text-field
					v-model="parameters.location"
					label="Местоположение"
					:disabled="!allowEditBase"
					@change="gotChanges = true"
				></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<v-text-field
					v-model="parameters.rooms"
					label="Количество номеров"
					:disabled="!allowEditBase"
					@change="gotChanges = true"
				></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<v-subheader>Название точек питания</v-subheader>
				<v-text-field
					v-model="parameters.rest1"
					label="Название основного ресторана"
					@change="gotChanges = true"
				></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<v-text-field
					v-model="parameters.rest2"
					label="Название второго ресторана"
					@change="gotChanges = true"
				></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<v-text-field
					v-model="parameters.rest3"
					label="Название третьего ресторана"
					@change="gotChanges = true"
				></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<v-text-field
					v-model="parameters.rest4"
					label="Название четвертого ресторана"
					@change="gotChanges = true"
				></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<v-text-field
					v-model="parameters.lobby"
					label="Название лобби бара"
					@change="gotChanges = true"
				></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<v-text-field
					v-model="parameters.lounge"
					label="Название лаунжа"
					@change="gotChanges = true"
				></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<v-subheader>Получатели отчетов</v-subheader>
				<v-text-field
					v-model="parameters.drrRecipients"
					label="Получатели DRR"
					@change="gotChanges = true"
				></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<v-text-field
					v-model="parameters.plRecipients"
					label="Получатели P&L отчетов"
					@change="gotChanges = true"
				></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<v-text-field
					v-model="parameters.fcstRecipients"
					label="Получатели прогнозных P&L"
					@change="gotChanges = true"
				></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<v-subheader>Параметры заявок на расходы и платежные ордеров</v-subheader>
				<v-switch
					v-model="parameters.purchasingDept"
					label="Есть отдел закупок"
					@change="gotChanges = true"
				></v-switch>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<v-switch
					v-model="parameters.gmApprovesPo"
					label="GM согласовывает платежные ордера"
					@change="updateGmApprovesPo"
				></v-switch>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<a-number-field
					v-model="parameters.gmApprovesPoFrom"
					label="Минимальная сумма платежного ордера для согласования GM (руб.)"
					hint="Укажите 0, чтобы GM согласовывал все ордера"
					:disabled="!parameters.gmApprovesPo"
					@input="gotChanges = true"
				></a-number-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<v-switch
					v-model="parameters.gmApprovesMmPr"
					label="GM согласовывает заявки на закупку по ведомости мини-макс"
					@change="updateGmApprovesMmPr"
				></v-switch>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6">
				<a-number-field
					v-model="parameters.gmApprovesMmPrFrom"
					label="Минимальная сумма заявки на закупку по ведомости мини-макс для согласования GM (руб.)"
					hint="Укажите 0, чтобы GM согласовывал все заявки"
					:disabled="!parameters.gmApprovesMmPr"
					@input="gotChanges = true"
				></a-number-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<v-btn
					@click="save"
					color="primary"
					:disabled="!gotChanges"
				>
					Сохранить
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import {api} from '../../lib/api'
import aHotelSelect from '../base/AHotelSelect.vue'
import aNumberField from '../base/ANumberField.vue'

export default {
	components: {
		aHotelSelect,
		aNumberField
	},
	data: () => ({
		parameters: {
			operating: true,
			code: '',
			name: '',
			rooms: '',
			location: '',
			rest1: '',
			rest2: '',
			rest3: '',
			rest4: '',
			lobby: '',
			lounge: '',
			drrRecipients: '',
			plRecipients: '',
			fcstRecipients: '',
			purchasingDept: false,
			gmApprovesPo: false,
			gmApprovesPoFrom: 0,
			gmApprovesMmPr: false,
			gmApprovesMmPrFrom: 0,
		},
		gotChanges: false,
		hotelCode: '',
		hotels: null,
	}),
	computed: {
		allowEditBase() {
			return this.$store.getters.userHasRight('hotel_base_parameters_edit')
		}
	},
	created() {
		if (this.$store.getters.userHo) {
			this.hotels = this.$store.getters.allHotels
		}
		else {
			this.hotels = this.$store.getters.userHotels
		}

		let selHotelCode = this.$store.getters.selectedHotelCode

		if (selHotelCode && this.hotels.find(el => el.code == selHotelCode)) {
			this.hotelCode = selHotelCode
		}
		else {
			this.hotelCode = this.hotels[0].code
			this.$store.dispatch('setSelectedHotelCode', this.hotelCode)
		}

		this.getParameters()
	},
	methods: {
		getParameters() {
			api.post('pref/get_hotel_parameters', {
				hotelCode: this.hotelCode
			})
			.then(response => {
				this.parameters = response.data.parameters
			})
		},
		save() {
			api.post('pref/set_hotel_parameters', {
				hotelCode: this.hotelCode,
				parameters: this.parameters
			})
			.then(response => {
				this.gotChanges = false
				this.$store.dispatch('dialogDone')
			})
		},
		updateGmApprovesPo(e) {
			this.gotChanges = true
			if (!e) {
				this.parameters.gmApprovesPoFrom = 0
			}
		},
		updateGmApprovesMmPr(e) {
			this.gotChanges = true
			if (!e) {
				this.parameters.gmApprovesMmPrFrom = 0
			}
		},
	},
}
</script>
